module.exports = __webpack_public_path__ + "img/2017-10-01_18-33-44.ef0f199b.jpg";